<template>
  <component :is="this.tatId ? 'MultiShareNewWay' : ''"></component>
</template>

<script>
// import MultiShareNormal from './MultiShareNormal'
import MultiShareNewWay from "./MultiShareNewWay";
import { mapGetters } from "vuex";
export default {
  name: "MultiShare",
  computed: {
    ...mapGetters(["tatId"]),
  },
  components: {
    MultiShareNewWay,
  },
  mounted() {},
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/AppManager/MultiShare.vue